export default class FinesseAnnouncementBar extends HTMLElement {
  active: boolean = false
  display: string = this.getAttribute('display') || 'static'

  static get observedAttributes() {
    return ['active']
  }

  constructor() {
    super()
  }

  get isActive() {
    return this.active
  }

  set isActive(value: boolean) {
    this.active = value
  }

  connectedCallback() {
    this.className = 'fixed flex top-0 left-0 w-full z-50 opacity-100 transition-all duration-200 ease-in-out hidden'

    const hasAnnouncement = this.getAttribute('active') === 'true'

    console.log('announcementBar hasAnnouncement', hasAnnouncement)

    if (!hasAnnouncement) {
      return
    }

    this.classList.remove('hidden')

    const announcementHeight: number = this.offsetHeight as number

    (window as any).dispatchEvent(new CustomEvent('announcement:toggle', { bubbles: true, detail: { active: hasAnnouncement, display: this.display, height: announcementHeight } }))

    window.addEventListener('announcement:toggle', this.handleAnnouncement.bind(this) as EventListener)
  }

  handleAnnouncement(event: CustomEvent) {
    this.isActive = event.detail.active
  }

  attributeChangedCallback(name: string, old: string, current: string) {
    if (old === current) {
      return
    }

    if (name === 'active') {
      this.isActive = current === 'true' ? true : false
    }
  }
}

customElements.define('finesse-announcement-bar', FinesseAnnouncementBar)
